// extracted by mini-css-extract-plugin
export var container = "_u9-0";
export var table = "_u9-2";
export var tableWrapper = "_u9-1";